<div class="container">
    <!-- Main View (when testInProgress is false and showResultsView is false) -->
    <div *ngIf="!testInProgress && !showResultsView">
        <!-- Header with breadcrumb -->
        <div class="header-row">
            <div class="header-left">
                <span class="breadcrumb">Descubrete > <span class="breadcrumb-active">Análisis profundo</span></span>
            </div>
        </div>

        <!-- Main content -->
        <div class="main-content">
            <!-- Page Header -->
            <div class="page-header">
                <h1 class="page-title">Análisis profundo</h1>
                <p class="page-description" *ngIf="!areAllDimensionsCompleted()">
                    Completa cada uno de los cuadrantes para agendar la primera sesión con tu mentor, tienes 7 días desde hoy por cada cuadrante.
                </p>
                <div *ngIf="areAllDimensionsCompleted()" class="results-completed-header">
                    <div class="results-content">
                        <h2 class="results-title">Resultados</h2>
                        <p class="results-description">Visualiza aqui tus resultados y agenda con tu mentor para continuar con tu plan de vida</p>
                    </div>
                    <div class="header-actions">
                        <button class="btn-clear-results" *ngIf="showClearButton" (click)="clearAllResults()" [disabled]="isClearingResults">
                            <i class="fas fa-trash-alt"></i>
                            <span>{{ isClearingResults ? 'Limpiando...' : 'Limpiar resultados' }}</span>
                        </button>
                        <button class="btn-download-pdf" (click)="downloadPdf()" [disabled]="isClearingResults">
                            <span>DescargarPDF</span>
                            <i class="fas fa-file-pdf"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Horizontal Stepper -->
            <!-- <div class="stepper-container">
                <div class="stepper">
                    <div class="stepper-step" [ngClass]="{'completed': step.completed, 'active': step.active, 'pending': !step.completed && !step.active}" 
                         *ngFor="let step of stepperSteps; let i = index">
                        <div class="step-number">
                            <span *ngIf="step.completed" class="check-icon">✓</span>
                            <span *ngIf="!step.completed">{{i + 1}}</span>
                        </div>
                        <div class="step-content">
                            <div class="step-name">{{step.name}}</div>
                            <div class="step-status">{{step.status}}</div>
                        </div>
                        <div class="step-connector" *ngIf="i < stepperSteps.length - 1"></div>
                    </div>
                </div>
            </div> -->
        </div>

        <!-- Tests List -->
        <div class="tests-list">
            <div class="test-item" *ngFor="let test of tests; trackBy: trackByTestId" [ngClass]="{'completed': test.progress === 100}">
                <div class="test-content">
                    <div class="test-title">
                        <span class="test-number">{{getTestNumber(test)}}</span>
                        <span class="test-name">{{getTestName(test)}}</span>
                    </div>
                    <div class="test-progress-section">
                        <div class="progress-bar">
                            <div class="progress-fill" [ngClass]="{'completed': test.progress === 100}" [style.width.%]="test.progress"></div>
                        </div>
                        <span class="progress-percentage">{{ test.progress }}%</span>
                        <div class="test-actions">
                            <!-- <button *ngIf="test.progress < 100" class="btn-start" (click)="startTest(test)">
                                <i class="fas" [ngClass]="test.progress > 0 ? 'fa-edit' : 'fa-play'"></i>
                                <span>{{ test.progress > 0 ? 'Continuar' : 'Iniciar' }}</span>
                            </button> -->
                            <button class="btn-edit" *ngIf="test.progress < 100" (click)="startTest(test)">
                                <i class="fas" [ngClass]="test.progress > 0 ? 'fa-pencil-alt' : 'fa-play'"class="fas fa-pencil-alt"></i>
                            </button>
                            <button *ngIf="test.progress === 100" class="btn-matrices" (click)="toggleDimensionMatrices(getTestId(test))">
                                <i class="fas" [ngClass]="isDimensionExpanded(getTestId(test)) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </button>
                        </div>
                    </div>
                </div>
            
            <div *ngIf="test.progress === 100 && isDimensionExpanded(getTestId(test))" class="dimension-matrices">
              <div class="matrix-content">
                <div *ngFor="let dimension of test.dimensions; trackBy: trackByDimensionId" class="subdimension-matrix">
                  <h4 class="subdimension-title">Subdimensión: {{dimension.name}}</h4>
                  <div class="matrix-table-container">
                    <table class="matrix-table">
                      <thead>
                        <tr>
                          <th>Área</th>
                          <th class="hide-mobile">Análisis Presente</th>
                          <th class="hide-mobile">Análisis Futuro</th>
                          <th>Brecha por Cerrar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let question of dimension.questions; let i = index; trackBy: trackByQuestionIndex">
                          <td class="area-name">{{i + 1}}. {{question.name}}</td>
                          <td class="analysis-value hide-mobile">{{question.answer?.valueNow || 0}}</td>
                          <td class="analysis-value hide-mobile">{{question.answer?.valueFuture || 0}}</td>
                          <td class="gap-cell" [ngClass]="getGapClass(calculateGap(question))">
                            {{calculateGap(question)}}
                          </td>
                        </tr>
                        <tr class="average-row">
                          <td class="area-name"><strong>Promedio</strong></td>
                          <td class="analysis-value hide-mobile"><strong>{{getAveragePresent(dimension.questions)}}</strong></td>
                          <td class="analysis-value hide-mobile"><strong>{{getAverageFuture(dimension.questions)}}</strong></td>
                          <td class="gap-cell"><strong>{{getAverageGap(dimension.questions)}}</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            </div>
        </div>

        <!-- Botón para desplegar matrices de resultados (solo si todas las dimensiones están al 100%) -->
        <div *ngIf="areAllDimensionsCompleted()" class="results-matrices-section" style="display: none;">
            <button class="btn-toggle-matrices" (click)="toggleResultsMatrices()">
                <i class="fas" [ngClass]="showResultsMatrices ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                <span>{{ showResultsMatrices ? 'Ocultar' : 'Ver' }} Matrices de Resultados</span>
            </button>
            
            <!-- Matrices de resultados desplegables -->
            <div *ngIf="showResultsMatrices" class="matrices-container">
                <div *ngFor="let test of tests" class="dimension-matrix">
                    <h3 class="matrix-title">{{test.dimensions[0].area.name}}</h3>
                    <div class="matrix-content">
                        <div *ngFor="let dimension of test.dimensions" class="subdimension-matrix">
                            <h4 class="subdimension-title">Subdimensión: {{dimension.name}}</h4>
                            <div class="matrix-table-container">
                                <table class="matrix-table">
                                    <thead>
                                        <tr>
                                            <th>Área</th>
                                            <th>Análisis Presente</th>
                                            <th>Análisis Futuro</th>
                                            <th>Brecha por Cerrar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let question of dimension.questions; let i = index; trackBy: trackByQuestionIndex">
                                            <td class="area-name">{{i + 1}}. {{question.name}}</td>
                                            <td class="analysis-value">{{question.answer?.valueNow || 0}}</td>
                                            <td class="analysis-value">{{question.answer?.valueFuture || 0}}</td>
                                            <td class="gap-cell" [ngClass]="getGapClass(calculateGap(question))">
                                                {{calculateGap(question)}}
                                            </td>
                                        </tr>
                                        <tr class="average-row">
                                            <td class="area-name"><strong>Promedio</strong></td>
                                            <td class="analysis-value"><strong>{{getAveragePresent(dimension.questions)}}</strong></td>
                                            <td class="analysis-value"><strong>{{getAverageFuture(dimension.questions)}}</strong></td>
                                            <td class="gap-cell"><strong>{{getAverageGap(dimension.questions)}}</strong></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Vista de Resultados (vista principal independiente) -->
    <div *ngIf="showResultsView" class="results-view">
        <!-- Header con breadcrumb -->
        <div class="header-row">
            <div class="header-left">
                <button class="btn-back" (click)="closeResultsView()">
                    <i class="fas fa-chevron-left"></i>
                </button>
                <span class="breadcrumb">Descubrete > Análisis profundo > {{testSelected?.dimensions?.[0]?.area?.name}} > <span class="breadcrumb-active">{{resultsData?.subdimensionName}}</span></span>
            </div>
        </div>

        <!-- Contenido principal -->
        <div class="results-content">
            <!-- Título y descripción -->
             
            <div class="results-header">
                <h1 class="results-title">{{resultsData?.subdimensionName}}</h1>
                <p class="results-subtitle">Detalles del análisis</p>
            </div>

            <!-- Leyenda de brechas -->
            <div class="gap-legend">
                <div class="legend-card">
                    <div class="card-content">
                        <p class="card-text">Fortaleza actual, mantener y reforzar y no descuidar.</p>
                        <div class="card-pointer"></div>
                    </div>
                    <div class="legend-item">
                        <div class="legend-icon low">
                            <i class="fas fa-question"></i>
                        </div>
                        <span class="legend-text">Brecha baja (1 a 3 puntos)</span>
                    </div>
                </div>
                <div class="legend-card">
                    <div class="card-content">
                        <p class="card-text">Área con oportunidades importantes de mejora.</p>
                        <div class="card-pointer"></div>
                    </div>
                    <div class="legend-item">
                        <div class="legend-icon medium">
                            <i class="fas fa-question"></i>
                        </div>
                        <span class="legend-text">Brecha media (4 a 6 puntos)</span>
                    </div>
                </div>
                <div class="legend-card">
                    <div class="card-content">
                        <p class="card-text">Oportunidad crítica que requiere acción inmediata.</p>
                        <div class="card-pointer"></div>
                    </div>
                    <div class="legend-item">
                        <div class="legend-icon high">
                            <i class="fas fa-question"></i>
                        </div>
                        <span class="legend-text">Brecha alta (7 a 9 puntos)</span>
                    </div>
                </div>
            </div>

            <!-- Tabla de resultados -->
            <div class="results-table-container">
                <table class="results-table">
                    <thead>
                        <tr>
                            <th>Área</th>
                            <th>Análisis presente</th>
                            <th>Análisis futuro</th>
                            <th>Brecha por cerrar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of resultsData?.tableData">
                            <td class="area-name">{{item.area}}</td>
                            <td class="analysis-value">{{item.presentAnalysis}}</td>
                            <td class="analysis-value">{{item.futureAnalysis}}</td>
                            <td class="gap-cell" [ngClass]="'gap-' + item.gapLevel">
                              {{item.gapToClose}}
                            </td>
                        </tr>
                        <tr class="average-row">
                            <td class="area-name"><strong>Promedio</strong></td>
                            <td class="analysis-value"><strong>{{resultsData?.averages?.presentAnalysis}}</strong></td>
                            <td class="analysis-value"><strong>{{resultsData?.averages?.futureAnalysis}}</strong></td>
                            <td class="gap-cell"><strong>{{resultsData?.averages?.gapToClose}}</strong></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Botón finalizar -->
            <div class="results-actions">
                <button class="btn-finish" (click)="finishTestFromResults()">
                    {{ getFinishButtonText() }}
                </button>
            </div>

            <!-- Lecturas recomendadas -->
            <div class="recommended-readings">
                <h3 class="readings-title">Lecturas recomendadas</h3>
                <div class="readings-grid">
                    <div class="reading-card" *ngFor="let reading of resultsData?.recommendedReadings">
                        <h4 class="card-title">{{reading.title}}</h4>
                        <p class="card-description">{{reading.description}}</p>
                        <a href="{{reading.link}}" class="card-link">{{reading.linkText}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div *ngIf="testInProgress && !showResultsView" class="test-in-progress">
        <!-- Header with breadcrumb -->
        <div class="header-row" *ngIf="!selectedSubdimension">
            <div class="header-left">
                <button class="btn-back" (click)="goBackToDimensions()">
                    <i class="fas fa-chevron-left"></i>
                </button>
                <span class="breadcrumb">Descubrete > Análisis profundo > <span class="breadcrumb-active">{{testSelected?.dimensions?.[0]?.area?.name}}</span></span>
            </div>
        </div>

        <!-- Main content -->
        <div class="main-content" *ngIf="!selectedSubdimension">
            <!-- Page Header -->
            <div class="page-header">
                <h1 class="page-title">Dimensión:  {{testSelected?.dimensions?.[0]?.area?.name}}</h1>
                <p class="page-description">Completa cada una de las subdimensiones.</p>
            </div>

        <!-- Subdimensions List -->
        <div class="tests-list" *ngIf="!isCompletingSubdimension">
            <!-- Debug info -->
            <div class="test-item" *ngFor="let subdimension of subdimensions; let i = index" [ngClass]="{'completed': subdimension.progress === 100}">
                    <div class="test-content">
                        <div class="test-title">
                            <span class="test-number">{{(i + 1).toString().padStart(2, '0')}}</span>
                            <span class="test-name">{{subdimension.name}}</span>
                        </div>
                        <div class="test-progress-section">
                            <div class="progress-bar">
                                <div class="progress-fill" [ngClass]="{'completed': subdimension.progress === 100}" [style.width.%]="subdimension.progress"></div>
                            </div>
                            <span class="progress-percentage">{{ subdimension.progress }}%</span>
                            <button class="btn-edit" (click)="startSubdimension(subdimension)">
                                <i class="fas fa-pencil-alt"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Navigation Buttons -->
            <div class="dimension-navigation">
                <button class="btn-back-dimensions" (click)="goBackToDimensions()">
                    Volver a dimensiones
                </button>
                <button class="btn-next-dimension" (click)="goToNextDimension()" [disabled]="!hasNextDimension()">
                    Siguiente dimensión
                </button>
            </div>
        </div>

        <!-- Subdimension Questions View -->
        <div *ngIf="selectedSubdimension && !isCompletingSubdimension" class="subdimension-questions">
            <!-- Header with breadcrumb -->
            <div class="header-row">
                <div class="header-left">
                    <button class="btn-back" (click)="goBackToSubdimensions()">
                        <i class="fas fa-chevron-left"></i>
                    </button>
                    <span class="breadcrumb">Descubrete > Análisis profundo > {{testSelected?.dimensions?.[0]?.area?.name}} > <span class="breadcrumb-active">{{selectedSubdimension?.subdimension?.name}}</span></span>
                </div>
            </div>

            <!-- Main content -->
            <div class="main-content">
                <!-- Page Header -->
                <div class="page-header">
                    <h1 class="page-title">Subdimensión: {{selectedSubdimension?.subdimension?.name}}</h1>
                    <p class="page-description">Tómate el tiempo necesario para realizar el análisis profundo de esta dimensión.</p>
                </div>

                <!-- Horizontal Stepper -->
                <div class="stepper-container">
                    <div class="stepper">
                        <div class="stepper-step" [ngClass]="{'completed': step.completed, 'active': step.active, 'pending': step.pending, 'clickable': step.completed || step.active}" 
                             *ngFor="let step of getStepperSteps(); let i = index"
                             (click)="goToStep(i + 1)">
                            <div class="step-content">
                                <div class="step-circle">
                                    <span *ngIf="step.completed" class="check-icon">✓</span>
                                </div>
                                <div class="step-label">{{i + 1}}</div>
                            </div>
                            <div class="step-connector" *ngIf="i < getStepperSteps().length - 1"></div>
                        </div>
                    </div>
                </div>

                <!-- Questions Content -->
                <div class="questions-content">
                    <div class="questions-main">
                        <div class="questions-section">
                            <h3 class="section-title">{{getCurrentSectionTitle()}}</h3>
                            <p class="section-description">Analiza todas las preguntas y desliza el cursor para responder con un puntaje del 1 al 10.</p>
                            
                            <div class="questions-list">
                                <div class="question-item" *ngFor="let question of currentQuestions; let i = index">
                                    <div class="question-content">
                                        <!-- <span class="question-number">{{question.originalIndex}}</span>
                                        <div class="question-text">{{question.text}}</div> -->
                                        <div class="test-title">
                                            <span class="test-number">{{question.originalIndex}}</span>
                                            <span class="test-name">{{question.text}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="questions-sidebar">
                        <div class="rating-section" [ngClass]="{'invalid-rating': currentSatisfaction > futureSatisfaction}">
                            <div class="rating-title">
                                <ol class="rating-title-list">
                                    <li><span class="bold-text">HOY</span>, ¿Qué tan satisfecho te sientes con {{getCurrentSectionTitle()}}?</li>
                                </ol>
                            </div>
                            <div class="slider-container">
                                <div class="slider-wrapper">
                                    <div class="slider-track">
                                        <div class="slider-fill" [style.width.%]="(currentSatisfaction - 1) * 11.11 + 1.5"></div>
                                        <div class="slider-thumb" [style.left.%]="(currentSatisfaction - 1) * 11.11">
                                        </div>
                                        <div class="slider-callout" [style.left.%]="(currentSatisfaction - 1) * 11.11">
                                            <span class="callout-value">{{currentSatisfaction}}</span>
                                        </div>
                                    </div>
                                    <input type="range" min="1" max="10" [value]="currentSatisfaction" 
                                           (input)="updateCurrentSatisfaction($event)" 
                                           class="slider-input">
                                </div>
                                <div class="slider-labels">
                                    <span class="slider-label-start">1</span>
                                    <span class="slider-label-end">10</span>
                                </div>
                            </div>
                            <div class="slider-legend">
                                <span class="legend-start">Muy insatisfecho</span>
                                <span class="legend-end">Muy satisfecho</span>
                            </div>
                            <!-- <div class="validation-message" *ngIf="currentSatisfaction > futureSatisfaction">
                                ⚠️ La satisfacción actual debe ser menor que la futura
                            </div> -->
                        </div>

                        <div class="rating-section" [ngClass]="{'invalid-rating': currentSatisfaction > futureSatisfaction}">
                            <div class="rating-title">
                                <ol class="rating-title-list" start="2">
                                    <li>¿Cómo quieres estar en el <span class="bold-text">LARGO PLAZO</span>?</li>
                                </ol>
                            </div>
                            <div class="slider-container">
                                <div class="slider-wrapper">
                                    <div class="slider-track">
                                        <div class="slider-fill" [style.width.%]="(futureSatisfaction - 1) * 11.11 + 1.5"></div>
                                        <div class="slider-thumb" [style.left.%]="(futureSatisfaction - 1) * 11.11">
                                        </div>
                                        <div class="slider-callout" [style.left.%]="(futureSatisfaction - 1) * 11.11">
                                            <span class="callout-value">{{futureSatisfaction}}</span>
                                        </div>
                                    </div>
                                    <input type="range" min="1" max="10" [value]="futureSatisfaction" 
                                           (input)="updateFutureSatisfaction($event)" 
                                           class="slider-input">
                                </div>
                                <div class="slider-labels">
                                    <span class="slider-label-start">1</span>
                                    <span class="slider-label-end">10</span>
                                </div>
                            </div>
                            <div class="slider-legend">
                                <span class="legend-start">Muy insatisfecho</span>
                                <span class="legend-end">Muy satisfecho</span>
                            </div>
                            <!-- <div class="validation-message" *ngIf="currentSatisfaction > futureSatisfaction">
                                ⚠️ La satisfacción futura debe ser mayor que la actual
                            </div> -->
                        </div>
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="action-section">
                    <button class="btn-back-action" (click)="goToStep(currentStep - 1)" [disabled]="currentStep === 1 || isSaving">
                        <i class="fas fa-chevron-left"></i>
                        <span>Atrás</span>
                    </button>
                    <button class="btn-next" (click)="nextStep()" [disabled]="isSaving">
                        <span *ngIf="isSaving">Guardando...</span>
                        <span *ngIf="!isSaving">{{ getNextButtonText() }}</span>
                        <i class="fas fa-chevron-right"></i>
                    </button>
                    <div *ngIf="saveError" class="error-message">
                        {{ saveError }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Mensaje de carga al completar subdimensión -->
    <div *ngIf="isCompletingSubdimension" class="completing-subdimension-overlay">
        <div class="completing-subdimension-content">
            <div class="loading-spinner"></div>
            <p class="loading-message">Guardando subdimensión...</p>
        </div>
    </div>
</div>

<!-- Modal de Finalización del Test -->
<div class="modal-overlay" *ngIf="showCompletionModal" (click)="closeCompletionModal()">
    <div class="modal-container" (click)="$event.stopPropagation()">
        <!-- Imagen de fondo -->
        <div class="modal-image">
            <img src="assets/img/trophy-completion.jpg" alt="Test completado" />
        </div>
        
        <!-- Contenido del modal -->
        <div class="modal-content">
            <div class="modal-container-inner">
                <h2 class="modal-title">¡Felicidades {{ authUser?.name || 'nombre' }}!</h2>
                <p class="modal-subtitle">
                    Has completado tu Assessment Profundo.
                </p>
                <p class="modal-description modal-description-justified">
                    Continúa con tu <strong>Guía de Reflexión Personal</strong> para profundizar en tus resultados. Recuerda agendar tu sesión con tu <strong>Mentor</strong> para revisar resultados y construir tu plan de vida.
                </p>
            </div>
            
            <!-- Botones del modal -->
            <div class="modal-buttons">
                <button class="btn-modal btn-secondary" (click)="closeCompletionModal()">
                    Cerrar
                </button>
                <button class="btn-modal btn-primary" (click)="finishTestCompletely()">
                    Continuar
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal de Dimensión Incompleta -->
<div class="modal-overlay" *ngIf="showIncompleteDimensionModal" (click)="closeIncompleteDimensionModal()">
    <div class="incomplete-dimension-modal" (click)="$event.stopPropagation()">
        <!-- Imagen de fondo -->
        <div class="incomplete-modal-image">
            <img src="https://www.figma.com/api/mcp/asset/afbac0ed-7a87-4e70-a4ae-c9825866211d" alt="Advertencia" />
        </div>
        
        <!-- Contenido del modal -->
        <div class="incomplete-modal-content">
            <div class="incomplete-modal-text">
                <h3 class="incomplete-modal-title">Aún no terminas esta dimensión</h3>
                <p class="incomplete-modal-description">
                    Has completado solo una parte de tu análisis. Para cerrar esta dimensión y avanzar con mayor claridad en tu evaluación personal, te invitamos a completar también la subdimensión pendiente. Recuerda: <strong>tu progreso se guarda automáticamente.</strong>
                </p>
            </div>
            
            <!-- Botones del modal -->
            <div class="incomplete-modal-buttons">
                <button class="btn-incomplete-modal btn-incomplete-secondary" (click)="closeIncompleteDimensionModal()">
                    Salir
                </button>
                <button class="btn-incomplete-modal btn-incomplete-primary" (click)="continueCompletingDimension()">
                    Completar ahora
                </button>
            </div>
        </div>
    </div>
</div>